(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('LogsService', LogsService);

    /* @ngInject */    
    function LogsService ($resource) {
        var service = $resource('api/system/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
